import { Injectable } from '@angular/core';
import { HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})

export class ConstantsService {
	public httpOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
	public httpCustomOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json, application/x-www-form-urlencoded;charset=ISO-8859-15',
			'Accept': 'application/json',
			'Origin':'http://localhost:4200'
		})
	};

	public baseAPIURL = '';
	constructor() {
		this.baseAPIURL = environment.baseAPIURL;
	}
}